import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { RadioButtonGroupInput, useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { TextModelEmail } from "../GeneratedClients/FreeBillApi";

const RadioButtonTextModelEmail = ({setShowTextModelEmail, textModelEmail} : {
  textModelEmail?: TextModelEmail, 
  setShowTextModelEmail: Dispatch<SetStateAction<"show" | "hide" | undefined>>
}) => {
  const { setValue } = useFormContext()
  const translate = useTranslate()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setShowTextModelEmail(event.target.value as "show" | "hide");
    setValue("textModelEmail", event.target.value === "hide" ? null : textModelEmail)
  }

  return (
    <RadioButtonGroupInput 
      onChange={handleChange}
      helperText={false}
      label={false}
      source="configTextModel"
      choices={[
        { id: 'hide', name: translate('resources.textTemplates.action.hideTextModel')},
        { id: 'show', name: translate('resources.textTemplates.action.showTextModelEmail')},
      ]}
    />
  )
}

export default RadioButtonTextModelEmail